module.exports = __webpack_public_path__ + "static/media/doksi.8b055de0.svg";